module.exports = __webpack_public_path__ + "img/poster.7f09f143.jpg";